var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "room-selector",
      class: {
        _selected: _setup.isBooked(),
        toolbar: "toolbar" === _setup.props.For,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "room-selector__wrapper",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _setup.detail_click.apply(null, arguments)
            },
          },
        },
        [
          _c("span", { staticClass: "room-selector__name" }, [
            _vm._v(_vm._s(_setup.props.Cabin.name)),
          ]),
          _vm._v(" "),
          !_setup.isBooked()
            ? _c(_setup.Mest, {
                staticClass: "room-selector__mest",
                attrs: { acc: _setup.props.Cabin.acc },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.isBooked()
            ? _c("span", { staticClass: "room-selector__mest" }, [
                _vm._v(_vm._s(_setup.gostey(_setup.occupation))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.RoomModal, {
        attrs: {
          Cabin: _setup.props.Cabin,
          CabinSet: _setup.props.CabinSet,
          modalShown: _setup.isModalShown,
        },
        on: { input: _setup.set_isModalShown },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }